export default __webpack_public_path__ + "static/media/credit_card.87b8832f.png";